import {
  KaishaDataSet,
  KaishaSearchParam,
  KaishaBaitaiShosaiDataSet,
  KaishaBaitaiShosaiSearchParam,
} from "../types/WebData";
import API from "./api";
import * as MESSAGE from "../const/message";
import { HTTP_STATUS_CODE } from "../const/index";

/**
 * kaishaテーブルAPI
 * 会社詳細情報取得
 *
 * @param {number} kaishaId
 * @return {*}
 */
export const getSearchKaishaId = async (kaishaId: number) => {
  const result = await API.get(`/cms-api/kaisha/id`, {
    params: { id: kaishaId },
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });

  return result;
};

/**
 * kaishaテーブルAPI
 * 会社情報検索
 *
 * @param {KaishaSearchParam} searchParam
 * @return {*}
 */
export const postSearchKaisha = async (searchParam: KaishaSearchParam) => {
  const result = await API.post(`/cms-api/kaisha/search`, searchParam)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });

  return result;
};

/**
 * kaishaテーブルAPI 更新
 *
 * @param {KaishaDataSet} postData
 */
export const updateKaisha = async (postData: KaishaDataSet) => {
  if (postData.id === 0) {
    // insert
    const result = await API.post("/cms-api/kaisha", postData)
      .then((res) => {
        return { isError: false, message: MESSAGE.TOROKU_SEIKO };
      })
      .catch((error) => {
        return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
      });
    return result;
  } else {
    // update
    const result = await API.put("/cms-api/kaisha/id", postData)
      .then((res) => {
        return { isError: false, message: MESSAGE.KOSHIN_SEIKO };
      })
      .catch((error) => {
        const status = error.response.status;
        const message =
          status === HTTP_STATUS_CODE.CONFLICT_ERROR
            ? MESSAGE.CONFLICT_ERROR
            : MESSAGE.SYSTEM_ERROR;
        return { isError: true, message: message, data: [] };
      });
    return result;
  }
};

/**
 * kaishaテーブルAPI del_flg更新
 *
 * @param {number} id
 * @param {boolean} del_flg
 */
export const deleteKaisha = async (id: number, del_flg: boolean) => {
  const result = await API.put("/cms-api/kaisha/delete", {
    id: id,
    del_flg: del_flg,
  })
    .then((res) => {
      return { isError: false, message: "" };
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });
  return result;
};

/**
 * kaishaテーブルAPI
 * 会社媒体詳細紐付け設定保存
 *
 * @param {MansionStaffData} rows
 * @return {*}
 */
export const postInsertKaishaBaitaiShosai = async (
  kaishaId: number,
  rows: KaishaBaitaiShosaiDataSet[] | null
) => {
  const result = await API.post(`/cms-api/kaisha/baitaiShosai/create`, {
    kaisha_id: kaishaId,
    rows: rows,
  })
    .then(() => {
      return {
        isError: false,
        message: MESSAGE.TOROKU_SEIKO,
        data: [],
      };
    })
    .catch(() => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });

  return result;
};

/**
 * kaishaテーブルAPI
 * 会社媒体詳細情報検索
 *
 * @param {KaishaBaitaiShosaiSearchParam} searchParam
 * @return {*}
 */
export const postSearchKaishaBaitaiShosai = async (
  searchParam: KaishaBaitaiShosaiSearchParam
) => {
  const result = await API.post(`/cms-api/kaisha/baitaiShosai`, searchParam)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });

  return result;
};
